import React, { Component } from 'react';
import classNames from 'classnames';
import LeadBorderTop from 'components/LeadBorderTop';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import * as CustomPropTypes from 'lib/CustomPropTypes';
import BTE from 'lib/BTE';
import { NAVBAR_THEME } from 'lib/navbar';
import { Rail, RailContainer } from 'components/Rail';
import OneUp from 'components/packages/OneUp';
import TwoUp from 'components/packages/TwoUp';
import TeasePicture from 'components/TeasePicture';
import Ad from 'components/Ad';
import Link from 'components/Link';
import { setTheme as setThemeAction } from 'redux/modules/navbar';
import nbcBrandStudioIcon from 'components/logos/nbcBrandStudio';
import PackageHeader from 'components/PackageHeader';

import TitleLogo from 'components/TitleLogo';
import AIMS_FLAVORS from 'lib/aimsFlavors';

// TODO: [BENTO-12233] Handle grid styling with the new theming system
// Temporarily leaving this stylesheet to handle grid only styles
// until different solution for grid is implemented within new theming strategy
import styles from './styles.module.scss';

const mapStateToProps = ({
  layout,
  navbar,
  shared,
}) => ({
  triggerTop: layout.triggerTop,
  navTheme: navbar.theme,
  vertical: shared.vertical,
});

const mapActionsToProps = (dispatch) => ({
  setTheme: (theme) => dispatch(setThemeAction(theme)),
});

@connect(
  mapStateToProps,
  mapActionsToProps,
)
class LeadSectionFront extends Component {
  static propTypes = {
    content: CustomPropTypes.package.isRequired,
    isRailAdjacent: PropTypes.bool,
    vertical: PropTypes.string,
    setTheme: PropTypes.func.isRequired,
    navTheme: PropTypes.string.isRequired,
    pkgClassName: PropTypes.string,
    triggerTop: PropTypes.number,
  }

  static defaultProps = {
    isRailAdjacent: false,
    vertical: null,
    pkgClassName: 'pkg leadSectionFront',
    triggerTop: 0,
  }

  componentDidMount() {
    BTE.on('scroll', this.handleScroll, 'throttle');
  }

  componentWillUnmount() {
    BTE.remove('scroll', this.handleScroll);
  }

  handleScroll = (depth) => {
    const {
      triggerTop,
      navTheme,
      setTheme,
      vertical,
      content: { metadata: { imageUrl } = {} } = {},
    } = this.props;

    if (depth > triggerTop && navTheme !== NAVBAR_THEME.LIGHT) {
      setTheme(NAVBAR_THEME.LIGHT);
      return;
    }

    if (depth <= triggerTop && (vertical === 'today' || (vertical === 'news' && imageUrl))) {
      if (navTheme !== NAVBAR_THEME.TRANSPARENT_LIGHT) {
        setTheme(NAVBAR_THEME.TRANSPARENT_LIGHT);
      }
      return;
    }

    if (depth <= triggerTop && navTheme !== NAVBAR_THEME.TRANSPARENT) {
      setTheme(NAVBAR_THEME.TRANSPARENT);
    }
  }

  paidContentHeader = () => (
    <div className="lead-section-front__paid-hub-container">
      <div className="lead-section-front__paid-header">
        <h3 className="f5 founders-cond ttu">paid content</h3>
      </div>
      <div className={classNames('lead-section-front__icons', 'df')}>
        <div>{nbcBrandStudioIcon()}</div>
        <div className="lead-section-front__line" />
        <div>
          <Ad
            slot="sponsorlogo"
            refreshInterval={0}
          />
        </div>
      </div>
    </div>
  )

  navItem = (item, i) => (
    <li key={`${item.linkUrl}${i}`}>
      <Link href={item.linkUrl}>
        {item.linkTitle}
      </Link>
    </li>
  );

  headerImage() {
    const { vertical, content: { metadata = {} } } = this.props;
    const { title, imageUrl } = metadata;

    if (!imageUrl) {
      if (vertical === 'today') {
        const typographyClasses = ['publico-hed', 'fs-italic', 'fw3', 'ml0-l', 'lh-none'];
        return (
          <div className={classNames('lead-section-front__today-big-heading', typographyClasses, 'dn db-m')}>
            {/*
              using `div`s here because these are semantically "null" elements
              that are for design only and are not meant to be read
            */}
            <div className={classNames('lead-section-front__today-big-heading-solid', 'plum')}>
              {title}
            </div>
            <div className="lead-section-front__today-big-heading-dots">
              {title}
            </div>
          </div>
        );
      }
      return null;
    }

    return (
      <TeasePicture
        className="lead-section-front__header-image"
        url={imageUrl}
        alt={title}
        responsiveFlavors={{
          s: AIMS_FLAVORS.FOCAL_320x320,
          m: AIMS_FLAVORS.FOCAL_630x630,
        }}
      />
    );
  }

  hero() {
    const { content: { items }, vertical } = this.props;

    return (
      <div className="lead-section-front__hero">
        <OneUp
          content={{ items: [items[0]] }}
          propStyles="tease-card__lead-section-front"
          vertical={vertical}
        />
      </div>
    );
  }

  headerContent() {
    const { content = {}, vertical } = this.props;
    const { metadata = {}, packageIndex } = content || {};
    const {
      title, description, imageUrl, logoUrl,
    } = metadata || {};

    const hasImg = imageUrl && vertical === 'news' ? 'lead-section-front--has-img' : '';
    const isPaidHub = vertical === 'sponsoredcontent';
    const spacingClasses = {
      'mb8-l': !isPaidHub,
      'ml7-m': true,
      'ml0-l': true,
      'mt8 mt0-l': !imageUrl,
    };
    return (
      <div
        className={classNames(
          'lead-section-front__header-content',
          hasImg,
          spacingClasses,
          { 'lead-section-front__paid-hub': isPaidHub },
        )}
      >
        <div>
          {title
            && (
            <PackageHeader
              className="lead-section-front__header-title"
              packageIndex={packageIndex}
            >
              <TitleLogo logoUrl={logoUrl} title={title} />
            </PackageHeader>
            )}
          <p className="lead-section-front__header-dek">{description}</p>
        </div>
        {this.navigation('header')}
      </div>
    );
  }

  navigation(placement) {
    const {
      content: { metadata: { navigation, imageUrl } = {} } = {},
      vertical,
    } = this.props;

    if (!navigation || !navigation.length) return null;

    // rail placement needs to show on L and XL ONLY for no-image package
    // headerContent placement needs to show on S and M if no-image,
    // and all sizes if image is present
    const displayLogic = {
      'dn df-l flex-column': placement === 'rail' && !imageUrl,
      'df dn-l': placement === 'header' && !imageUrl,
      'df flex-column-l': placement === 'header' && imageUrl,
    };

    const fontStyles = [
      'f4 f7-m',
      'lh-none',
      !imageUrl ? 'f7-l' : '',
      placement === 'rail' && vertical !== 'today' ? 'founders-cond' : '',
      vertical === 'today' ? 'fs-italic publico-hed vermillion' : '',
    ];

    const spacingClasses = {
      'pv5 pv0-l': true,
      'mt8-l': placement === 'header',
      'mb8-l': placement === 'rail',
    };

    return (
      <ul
        className={classNames('lead-section-front__navigation', displayLogic, fontStyles, spacingClasses)}
      >
        {navigation.map(this.navItem)}
      </ul>
    );
  }

  render() {
    const {
      isRailAdjacent,
      vertical,
      content: {
        id, items, metadata = {}, packageIndex,
      },
      pkgClassName,
    } = this.props;
    const { imageUrl } = metadata;
    const isPaidHub = vertical === 'sponsoredcontent';
    const adClasses = {
      'mt10 boxflexAd': isPaidHub,
      ad: true,
    };
    const filteredMetadata = {
      ...metadata,
      title: null,
    };

    return (
      <div
        data-packageid={id}
        className={classNames(
          pkgClassName,
          `pkg-index-${packageIndex + 1}`,
          'mb8',
          styles['lead-section-front'],
          'lead-section-front',
          {
            'lead-section-front__has-image': imageUrl,
            'lead-section-front__no-grid-container': ['today', 'news', 'msnbc', 'sponsoredcontent', 'noticias', 'entretenimiento', 'shows'].includes(vertical),
            'lead-section-front__paid-hub': isPaidHub,
          },
        )}
        ref={(element) => { this.container = element; }}
      >
        <LeadBorderTop types={['collectionLead']} />
        <RailContainer className={classNames('lead-section-front__rail-container', 'lead-section-front__rail-container', 'layout-grid-container')}>
          {this.headerImage()}
          <Rail className={classNames('lead-section-front__rail', 'layout-grid-item grid-col-5-l grid-col-4-xl')}>
            {isPaidHub && this.paidContentHeader()}
            {this.headerContent()}
            {!imageUrl && this.navigation('rail')}
            <Ad slot="boxrail" sticky adClass={adClasses} />
          </Rail>
          <div className={classNames('layout-grid-item grid-col-7-l grid-col-8-xl')}>
            {this.hero()}
            <TwoUp
              content={{ items: items.slice(1, 3), metadata: filteredMetadata }}
              className="lead-section-front__two-up"
              vertical={vertical}
            />
            <OneUp
              content={{ items: [items[3]], metadata: filteredMetadata }}
              isRailAdjacent={isRailAdjacent}
              pkgClassName={pkgClassName}
              vertical={vertical}
            />
          </div>
        </RailContainer>
      </div>
    );
  }
}

export default LeadSectionFront;
